[
  {
    "code": "22",
    "label": "Consumer product variant",
    "ruleName": "cpv-value"
  },
  {
    "code": "10",
    "label": "Batch or lot number",
    "ruleName": "lot-value"
  },
  {
    "code": "21",
    "label": "Serial number",
    "ruleName": "ser-value"
  },
  {
    "code": "235",
    "label": "Third Party Controlled, Serialised Extension of GTIN (TPX)",
    "ruleName": "tpx-value"
  },
  {
    "code": "254",
    "label": "GLN extension component",
    "ruleName": "glnx-value"
  },
  {
    "code": "7040",
    "label": "GS1 UIC with Extension 1 and Importer index",
    "ruleName": "uic-ext-value"
  },
  {
    "code": "8011",
    "label": "Component/Part Identifier serial number (CPID SERIAL)",
    "ruleName": "cpsn-value"
  },
  {
    "code": "8019",
    "label": "Service Relation Instance Number (SRIN)",
    "ruleName": "srin-value"
  },
  {
    "code": "8020",
    "label": "Payment slip reference number",
    "ruleName": "refno-value"
  }
]
